import { AuthBy } from '@/util/composables/useLocalStorage'

export default ({ app }, inject) => {
  const { router, context, $paths } = app

  inject('newModal', {
    openBigModal(modalName, tab, noOldQuery = false) {
      const oldQuery = noOldQuery ? {} : { ...context.route.query }
      const query = {
        ...oldQuery,
        bigModal: modalName,
        bigModalTab: tab,
      }
      router.replace({ query })
    },
    openAuthWithLastMethod({ noOldQuery = false, id = '' } = {}) {
      /** Add and log id's if need debug */
      this.openBigModal('auth', AuthBy.value || 'phone', noOldQuery)
    },
    openRegistration({ noOldQuery = false } = {}) {
      this.openBigModal('registration', 'phone', noOldQuery)
    },
    openAuthOrRegister({ noOldQuery = false, id = '' } = {}) {
      /** Add and log id's if need debug */
      AuthBy.value
        ? this.openAuthWithLastMethod({ noOldQuery })
        : this.openRegistration({ noOldQuery })
    },
    async closeBigModal() {
      const query = { ...context.route.query }
      delete query.bigModal
      delete query.bigModalTab
      context.route.path === $paths.registration
        ? await router.push({ path: $paths.home, query })
        : await router.replace({ query: {} })
    },
    changeQueryParam(field, value, path, isRemoveOtherQuery) {
      const query = isRemoveOtherQuery ? {} : { ...context.route.query }
      query[field] = value
      router.replace({ path: !path ? path : app.localePath(path), query })
    },
    showLoaderData() {
      const isLoadingBlockExist = document.getElementById('loadingBlock')
      if (isLoadingBlockExist) return

      const htmlEl = document.querySelector('html')
      const bodyEl = document.querySelector('body')
      htmlEl.classList.add('open-modal')
      bodyEl.classList.add('body-open-modal')
      const loadingBlock = document.createElement('div')
      loadingBlock.classList.add('loadingBlock')
      loadingBlock.setAttribute('id', 'loadingBlock')
      const svgHtml = '<svg v-if="loaderStart"version="1.1"xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><path opacity="0.2" fill="#1d2531" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/><path fill="#1d2531" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/></path></svg>'
      loadingBlock.innerHTML = `<div class="loader">${svgHtml}</div>`
      document.body.appendChild(loadingBlock)
    },
    closeLoaderData() {
      const loadingBlock = document.getElementById('loadingBlock')
      if (loadingBlock) {
        const htmlEl = document.querySelector('html')
        const bodyEl = document.querySelector('body')
        htmlEl.classList.remove('open-modal')
        bodyEl.classList.remove('body-open-modal')
        loadingBlock.remove()
      }
    },
  })
}
